import { SectionDescriptionProps } from './types'

export function SectionDescription({
  children,
  className = '',
  ...props
}: SectionDescriptionProps) {
  return (
    <p
      className={`font-heading text-xl font-normal leading-7 tracking-normal md:text-2xl md:leading-8 ${className}`}
      {...props}
    >
      {children}
    </p>
  )
}
